import { useCallback, useRef } from 'react'
import { AuthStatus, init } from '@thoughtspot/visual-embed-sdk'

import { ThoughtSpotConfig } from '../utils/config'

export const useInitializeThoughtSpot = (userId: string) => {
  const initializedRef = useRef(false)

  const initializeThoughtSpot = useCallback(() => {
    if (initializedRef.current || !userId) {
      return
    }
    const eventEmitter = init(ThoughtSpotConfig(userId))
    if (eventEmitter) {
      eventEmitter
        .on(AuthStatus.SUCCESS, () => (initializedRef.current = true))
        .on(AuthStatus.SDK_SUCCESS, () => (initializedRef.current = true))
        .on(AuthStatus.FAILURE, () => (initializedRef.current = false))
    }
  }, [userId])
  initializeThoughtSpot()
}
